import { useLocation, useNavigate } from "@tanstack/react-router"
import React from "react"

interface Tab {
  key: string
  label: string
  path: string
  icon: string
}

const CRMLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const tabs: Tab[] = [
    { key: "dashboard", label: "Dashboard", path: "/crm", icon: "📊" },
    { key: "campaigns", label: "Campaigns", path: "/crm/campaigns", icon: "🚀" },
    { key: "contacts", label: "Contacts", path: "/crm/contacts", icon: "👥" },
    { key: "inbox", label: "Inbox", path: "/crm/inbox", icon: "📬" },
    { key: "accounts", label: "Accounts", path: "/crm/email-accounts", icon: "📬" },
    { key: "templates", label: "Templates", path: "/crm/templates", icon: "📝" },
    { key: "analytics", label: "Analytics", path: "/crm/analytics", icon: "📈" },
  ]

  // Determine active tab based on current path
  const getActiveTab = () => {
    const currentPath = location.pathname
    if (currentPath === "/crm") return "dashboard"
    if (currentPath.startsWith("/crm/campaigns")) return "campaigns"
    if (currentPath.startsWith("/crm/contacts")) return "contacts"
    if (currentPath.startsWith("/crm/inbox") || currentPath.startsWith("/crm/start-conversation")) return "inbox"
    if (currentPath.startsWith("/crm/email-accounts")) return "accounts"
    if (currentPath.startsWith("/crm/templates")) return "templates"
    if (currentPath.startsWith("/crm/analytics")) return "analytics"
    return "dashboard"
  }

  const activeTab = getActiveTab()

  const handleTabClick = (tab: Tab) => {
    navigate({ to: tab.path })
  }

  return (
    <div className="h-full flex flex-col bg-foregroundx ">
      {/* Tab Navigation */}
      <div className="bg-background  border-b border-border dark:border-gray-700 px-6">
        <div className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab)}
              className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center gap-2 transition-colors duration-200 ${
                activeTab === tab.key
                  ? "border-blue-500  dark:text-blue-400"
                  : "border-transparent text-gray-500 hover:text-primary hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }`}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden">{children}</div>
    </div>
  )
}

export default CRMLayout
